module.exports = __webpack_public_path__ + "static/VarshaPoddar.4b70077d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/VarshaPoddar.jpg
// module id = 248
// module chunks = 25111403944408 251948199435738